import 'css/index.css';
import { initializeArdoqPackages } from 'initializeArdoqPackages';
import { initRouter } from 'auth/AuthRouter';
import { initializeFeatureInterface } from 'modelInterface/features/initializeFeatureInterface';

initializeFeatureInterface();
initializeArdoqPackages();

initRouter();
